import React from 'react'
import vision from '../Image/vision.svg'
function Our_vision() {
  return (
    <div>
      {/* ------------------------------Mobile View--------------------------- */}
      <div className="d-sm-block d-md-none ">
        <div className="container-fluid pt-3">
          <div className="row">
            <div className="col-md-12">
              <img
                className="vision_img"
                src={vision}
                alt="Vision of InternsElite"
                title="Vision of InternsElite"
              ></img>
            </div>
            <div className="col-md-12">
              <div className="pt-4 vision_text vision_text_mobile  text-center">
                <h1 className="display-5 pb-1">Our Vision:</h1>
                <p>
                  Envisioning a future where education is a transformative
                  force, we aspire to be a global hub for advanced learning. Our
                  vision is to equip learners with the expertise and
                  adaptability needed to excel in their chosen fields, thereby
                  contributing to a world where knowledge is a catalyst for
                  positive change and continuous growth.
                </p>
              </div>
              <div className="vision_text vision_text_mobile pt-4 text-center border-bottom pb-3">
                <h1 className="display-5 pb-1">Our Mission:</h1>
                <p>
                  Empower individuals through cutting-edge education, offering
                  advanced courses and traineeships that transcend traditional
                  boundaries. We strive to cultivate a dynamic learning
                  environment, fostering skill development and innovation to
                  propel our learners towards success in the ever-evolving
                  landscape of knowledge.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------Desktop View-------------------------------- */}
      <div className="d-none d-md-block mb-2">
        <div className="container-fluid pt-4">
          <div className="row">
            <div className="col-xl-6">
              <div className="pt-5 px-5 vision_text">
                <h1 className="display-5 pb-2">Our Vision:</h1>
                <p>
                  Envisioning a future where education is a transformative
                  force, we aspire to be a global hub for advanced learning. Our
                  vision is to equip learners with the expertise and
                  adaptability needed to excel in their chosen fields, thereby
                  contributing to a world where knowledge is a catalyst for
                  positive change and continuous growth.
                </p>
              </div>
              <div className="vision_text px-5 pt-5 text-end">
                <h1 className="display-5 pb-2">Our Mission:</h1>
                <p>
                  Empower individuals through cutting-edge education, offering
                  advanced courses and traineeships that transcend traditional
                  boundaries. We strive to cultivate a dynamic learning
                  environment, fostering skill development and innovation to
                  propel our learners towards success in the ever-evolving
                  landscape of knowledge.
                </p>
              </div>
            </div>
            <div className="col-xl-6 pt-3">
              <img
                className="vision_img"
                src={vision}
                alt="Vision of InternsElite"
                title="Vision of InternsElite"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Our_vision
